import type { IContentDocumentDto, IContentDocumentResponse } from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPostApi } from "@api/util/createPostApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createDeleteApi } from "@api/util/createDeleteApi";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IContentDocumentResponse>>,
  IPathBaseParam,
  IPaginationParams
>("courses.contents.documents");
const postApis = createPostApi<
  IApiResponse<IContentDocumentResponse>,
  IPathBaseParam,
  IContentDocumentDto
>("courses.contents.documents");
const patchApis = createPatchApi<
  IApiResponse<IContentDocumentResponse>,
  IPathByIdParam,
  IContentDocumentDto
>("courses.contents.documents");
const deleteApis = createDeleteApi<
  IApiResponse<IContentDocumentResponse>,
  IPathByIdParam
>("courses.contents.documents");

export const documents = {
  ...getAllApis,
  ...postApis,
  ...patchApis,
  ...deleteApis,
};
